import React from 'react';

interface HeaderProps {
  title: string;
  subtitle: string;
}

const Header: React.FC<HeaderProps> = ({ title, subtitle }) => {
  return (
    <div>
      {title && <h4 className="text-[#6B778C] font-content">{title}</h4>}
      <h1 className="text-2xl text-[#172B4D] font-header">{subtitle}</h1>
    </div>
  );
};

export default Header;
